import { ITextureDrawable, instanceOfITextureDrawable } from "../../../../base/domain/drawing";
import { IShapeDrawableObject, instanceOfIShapeDrawableObject } from "./IShapeDrawableObject";
import { ElementTypes } from "./ElementTypes";

export interface ITexturedShapeDrawableObject extends IShapeDrawableObject, ITextureDrawable {}

export function instanceOfITexturedShapeDrawableObject<T extends ITexturedShapeDrawableObject>(instance: any, type: ElementTypes): instance is ITexturedShapeDrawableObject {
  return instance
      && instanceOfITextureDrawable(instance)
      && instanceOfIShapeDrawableObject<T>(instance, type);
}
